export default __webpack_public_path__ + "static/media/penumbra.9ad5b2a4.svg";